import React from "react";
import { Button } from "@showitinc/showit-wc";
import AppConstants from "../../constants/AppConstants";
import ControlBarButton from "../ControlBarButton";

const { STAGE_VIEW_SPLIT, STAGE_VIEW_MOBILE, STAGE_VIEW_DESKTOP } = AppConstants;

class PreviewFooter extends React.Component {
  _showView = (layout) => {
    if (this.props.onSelectLayout) {
      this.props.onSelectLayout(layout);
    }
  };

  render() {
    const { layout, actionEnabled, actionLabel, onActionClick, children } = this.props;

    const footerStyle = {
      display: "flex",
      height: 50,
      alightItems: "stretch",
    };

    const btnsLeftStyle = {
      display: "flex",
      height: "100%",
      flex: "0 0 15%",
    };
    const btnsMiddleStyle = {
      display: "flex",
      height: "100%",
      flex: "0 0 70%",
    };
    const btnsRightStyle = {
      height: "100%",
      display: "flex",
      justifyContent: "flex-end",
      flex: "0 0 15%",
      padding: 8,
    };

    return (
      <div style={footerStyle}>
        <div style={btnsLeftStyle}>
          <ControlBarButton
            icons="icon icon-mobiledesktop"
            active={STAGE_VIEW_SPLIT === layout}
            title="Show Mobile and Desktop"
            onClick={this._showView.bind(this, STAGE_VIEW_SPLIT)}
          />
          <ControlBarButton
            icons="icon icon-mobile"
            active={STAGE_VIEW_MOBILE === layout}
            title="Show Mobile Only"
            onClick={this._showView.bind(this, STAGE_VIEW_MOBILE)}
          />
          <ControlBarButton
            icons="icon icon-desktop"
            active={STAGE_VIEW_DESKTOP === layout}
            title="Show Desktop Only"
            onClick={this._showView.bind(this, STAGE_VIEW_DESKTOP)}
          />
        </div>
        <div style={btnsMiddleStyle}>{children}</div>
        <div style={btnsRightStyle}>
          {actionEnabled ? (
            <Button variant="feature" onSIClick={onActionClick}>
              {actionLabel}
            </Button>
          ) : null}
        </div>
      </div>
    );
  }
}

export default PreviewFooter;
